'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { getEmptyImage } from 'react-dnd-html5-backend';
import MenuItem from 'simple-menus-lib/components/menu/MenuItem';
import MenuNodeDivider from 'simple-menus-lib/components/menu/MenuNodeDivider';
import menuDragSource from 'simple-menus-lib/components/dnd/decorators/menuDragSource';
import DropPositions from 'simple-menus-core/enums/DropPositions';
import { setIsDragging } from 'simple-menus-core/actions/Application';
import { compose } from 'redux';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapDispatchToProps = {
  setIsDragging
};
class MenuNode extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false
    };
    this.toggleCollapse = this.toggleCollapse.bind(this);
  }
  componentDidMount() {
    this.props.connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }
  get classNames() {
    const {
      className,
      isDragging
    } = this.props;
    return classNames(className, 'simple-menus-menu-node', isDragging && 'is--dragged');
  }
  toggleCollapse() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }
  renderTopDivider() {
    const {
      id,
      depth,
      index,
      parentId,
      menuId,
      isDragging,
      isParentDragging,
      readOnly
    } = this.props;
    if (index === 0 && depth === 0) {
      return /*#__PURE__*/_jsx(MenuNodeDivider, {
        id: id,
        depth: depth,
        position: DropPositions.TOP,
        parentId: parentId,
        menuId: menuId,
        isParentDragging: isDragging || isParentDragging,
        readOnly: readOnly
      });
    }
    return null;
  }
  render() {
    const {
      id,
      parentId,
      children,
      getMenuComponent,
      connectDragSource,
      moveNode,
      isDragging,
      isParentDragging,
      depth,
      menuId,
      isLastChild,
      depthToNextSibling,
      hasSibling,
      hierarchy,
      readOnly
    } = this.props;
    const {
      collapsed
    } = this.state;
    // const newHierarchy = [...hierarchy, id];

    const MenuComponent = getMenuComponent(true);
    return connectDragSource( /*#__PURE__*/_jsxs("div", {
      className: this.classNames,
      children: [this.renderTopDivider(), /*#__PURE__*/_jsx(MenuItem, {
        id: id,
        parentId: parentId,
        moveNode: moveNode,
        isParentDragging: isDragging || isParentDragging,
        depth: depth,
        hasChildren: Boolean(children.length),
        toggleCollapse: this.toggleCollapse,
        isCollapsed: collapsed,
        menuId: menuId,
        readOnly: readOnly
      }), /*#__PURE__*/_jsx(MenuNodeDivider, {
        id: id,
        depth: depth,
        isCollapsed: collapsed,
        parentId: collapsed ? null : parentId,
        menuId: menuId,
        isParentDragging: isDragging || isParentDragging,
        isLastChild: isLastChild,
        hasChildren: !!children.length,
        hasSibling: hasSibling,
        depthToNextSibling: depthToNextSibling,
        hierarchy: hierarchy,
        readOnly: readOnly
      }), /*#__PURE__*/_jsx(MenuComponent, {
        parentId: id,
        nodes: children,
        getMenuComponent: getMenuComponent,
        moveNode: moveNode,
        isParentDragging: isDragging || isParentDragging,
        depth: depth + 1,
        isCollapsed: collapsed,
        menuId: menuId,
        depthToNextSibling: depthToNextSibling,
        hierarchy: [...hierarchy, id],
        readOnly: readOnly
      })]
    }));
  }
}
MenuNode.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  children: PropTypes.arrayOf(PropTypes.any).isRequired,
  getMenuComponent: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  moveNode: PropTypes.func.isRequired,
  isParentDragging: PropTypes.bool,
  className: PropTypes.string,
  isDragging: PropTypes.bool,
  depth: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  isLastChild: PropTypes.bool,
  depthToNextSibling: PropTypes.number,
  hasSibling: PropTypes.bool,
  hierarchy: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  readOnly: PropTypes.bool
};
MenuNode.defaultProps = {
  children: []
};
export default compose(connect(null, mapDispatchToProps), menuDragSource())(MenuNode);